module.exports = {"445381001":"罗城街道","445381002":"素龙街道","445381003":"附城街道","445381004":"双东镇街道","445381100":"罗镜镇","445381101":"太平镇","445381102":"分界镇","445381104":"罗平镇","445381105":"船步镇","445381106":"满塘镇","445381107":"苹塘镇","445381108":"金鸡镇","445381109":"围底镇","445381110":"华石镇","445381111":"林滨镇","445381113":"黎少镇","445381114":"生江镇","445381115":"连州镇","445381116":"泗纶镇","445381118":"加益镇","445381119":"龙湾镇","445381400":"罗平农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445381.json
// module id = 1894
// module chunks = 0